import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DrawerLayout from '../../components/shared/DrawerLayout';
import CarEditDrawerBody from './CarEditDrawerBody';
import { ViewMode } from '../../hooks/viewMode';
import AreaEditDrawer from '../../components/AreaEditDrawer';
import { selectSelectedCar } from '../../redux/store/userData/cars';
import {
  closeCarDrawerAndSetQueries,
  selectViewMode,
} from '../../redux/store/ui/common';
import ProfileEditDrawer from '../ProfileEditDrawer';
import { selectViewType } from '../../redux/store/ui/common/selectors';
import { ViewType } from '../../hooks/useViewType';
import NestedDrawer from '../shared/NestedDrawer';

const CarEditDrawer: React.FC = () => {
  const dispatch = useDispatch();
  const viewMode = useSelector(selectViewMode);
  const viewType = useSelector(selectViewType);
  const selectedCar = useSelector(selectSelectedCar);
  const visible = selectedCar != null;

  const handleOnClose = () => {
    dispatch(closeCarDrawerAndSetQueries());
  };

  return (
    selectedCar && (
      <>
        <DrawerLayout
          isCarEditDrawer
          visible={visible}
          title={selectedCar.id}
          body={<CarEditDrawerBody />}
          nestedDrawers={
            <>
              {viewMode !== ViewMode.AREA && <AreaEditDrawer />}
              {viewMode !== ViewMode.CLAIM && <NestedDrawer name="claim" />}
              {viewMode !== ViewMode.CATEGORIES && (
                <NestedDrawer name="categoryEdit" />
              )}
              {viewMode !== ViewMode.PROFILE && <ProfileEditDrawer />}
              {viewMode !== ViewMode.SHARE && <NestedDrawer name="trip" />}
              {viewMode !== ViewMode.BOOKING &&
                viewType !== ViewType.TIME_TABLE && (
                  <NestedDrawer name="booking" />
                )}
              {viewMode !== ViewMode.USERS && <NestedDrawer name="users" />}
            </>
          }
          onReload={undefined}
          onClose={handleOnClose}
        />
      </>
    )
  );
};

export default CarEditDrawer;
